import { text } from 'stream/consumers';
import { getApiClient } from '../services/apiBaseClient';
import { ProfileVariables, SurveyResponse, ErrorResponse } from '../types';
import { errorMessage } from './ErrorMessage';
import { showLoadingSpinner, hideLoadingSpinner } from './LoadingSpinner';

const surveyWrapperStyles = {
  textAlign: 'left',
  borderBottom: '1px solid black',
  padding: '12px 8px'
};

const surveyItemStyles = {
  // display: 'block',
  marginBottom: '8px',
  width: 'fit-content',
  cursor: 'pointer',
  borderBottom: '1px solid #fff0f0',
  padding: '8px'
};

const onSurveyClick = async (
  surveyId: string,
  respondentId?: string,
  profileVariables?: ProfileVariables
) => {
  const api = getApiClient();
  try {
    const response = await api.post<{ redirectUrl: string }>('/surveys/start', {
      data: {
        SurveyId: surveyId,
        RespondentId: respondentId,
        ...profileVariables,
      },
    });
    if (response.redirectUrl) {
      const newTab = window.open(response.redirectUrl, '_blank');
      if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
        window.location.href = response.redirectUrl;
      }
    }
  } catch (error) {
    errorMessage('Failed to start the survey. Please try again later.');
  }
};

export function renderSurveys(
  container: HTMLElement,
  surveys: SurveyResponse[] | ErrorResponse,
  respondentId?: string,
  profileVariables?: ProfileVariables
) {
  container.innerHTML = '';
  container.className = 'survey-container';

  if ('message' in surveys) {
    errorMessage(surveys.message, container);
    return;
  }

  if (surveys.length === 0) {
    errorMessage('There are no available surveys at the moment', container);
    return;
  }

  const createTableHeader = (headers: string[]) => {
    const headerRow = document.createElement('tr');
    headers.forEach((headerText) => {
      const th = document.createElement('th');
      th.innerText = headerText;
      Object.assign(th.style, surveyWrapperStyles);
      headerRow.appendChild(th);
    });
    return headerRow;
  };

  const createSurveyRow = (survey: SurveyResponse) => {
    const row = document.createElement('tr');
    row.className = 'survey-item';
    row.addEventListener('click', () =>
      onSurveyClick(survey.surveyId, respondentId, profileVariables)
    );

    const createCell = (content: string | HTMLElement) => {
      const cell = document.createElement('td');
      if (typeof content === 'string') {
        cell.innerText = content;
      } else {
        cell.appendChild(content);
      }
      Object.assign(cell.style, surveyItemStyles);
      return cell;
    };

    row.appendChild(createCell(`New Survey (${survey.surveyId})`));
    row.appendChild(createCell(`${survey.rewardPoints || 0} points`));
    row.appendChild(createCell(`${survey.loi} mins`));

    const playIcon = document.createElement('span');
    playIcon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#000">
        <path d="M8 5v14l11-7z"></path>
      </svg>
    `;
    row.appendChild(createCell(playIcon));

    return row;
  };

  const surveyWrapper = document.createElement('table');
  surveyWrapper.appendChild(
    createTableHeader(['Survey Name', 'Reward Points', 'Length', ' '])
  );

  surveys.forEach((survey) => {
    surveyWrapper.appendChild(createSurveyRow(survey));
  });

  container.appendChild(surveyWrapper);
}
